import React from "react";
import "./Hero.css";

function Hero() {
  return (
    <section className="hero" id="home">
      {/* Floating Background Blobs */}
      <div className="floating-blob blob1"></div>
      <div className="floating-blob blob2"></div>
      <div className="floating-blob blob3"></div>
      <div className="floating-blob blob4"></div>

      <div className="overlay"></div>
      <div className="hero-content">
        <img src="/sanjana.png" alt="Sanjana" className="profile-pic" />
        <h1 className="title">
          Hi, I'm <span>Sanjana</span>
        </h1>
        <p className="subtitle">Frontend Developer | AI-Powered Animated Videos Creator</p>

        {/* Button scrolls to projects section */}
        <a href="#projects" className="btn">
          View My Work
        </a>
      </div>
    </section>
  );
}

export default Hero;
